type Props = { quantity?: number; rewardName: string };
export const RewardCount = ({ quantity = 1, rewardName }: Props) => {
  return `${quantity}× ${rewardName}`;
};
